import { UseApiCallProps } from '@pages/lending/types';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useSelector } from 'react-redux';
import { useApiCall } from 'use-api-call';
import useImmediateApiCall from '@main-hooks/useImmediateApiCall';
import updateTransactionalProfile from '../api/updateTransactionalProfile.service';
import { UseTransactionalProfileResponse } from '../types';
import {
  UpdateTransactionalProfileService,
  UpdateTransactionalProfileServiceResponse,
  UpdateTransactionalProfileServiceData,
} from '../types/updateTransactionalProfileApi';

const useTransactionalProfileService = (): UseTransactionalProfileResponse => {
  const userProfile = useSelector(selectProfileData);
  const enterpriseId = userProfile?.company.enterpriseId || '0';
  const hasTransactionalProfile = !!userProfile?.hasTransactionalProfile;

  const {
    loading: loadingGet,
    data: existingProfileData,
    error: errorGet,
  } = useImmediateApiCall<UpdateTransactionalProfileServiceData>(() =>
    updateTransactionalProfile.getValues(enterpriseId)
  );

  const {
    loading: loadingUpdate,
    data: transactionalProfileData,
    error: errorUpdate,
    invoke: updateTransactionProfile,
  }: UseApiCallProps<
    UpdateTransactionalProfileServiceResponse,
    UpdateTransactionalProfileService['data']
  > = useApiCall((data: UpdateTransactionalProfileService['data']) =>
    hasTransactionalProfile || Object.keys(existingProfileData).length > 0
      ? updateTransactionalProfile.updateValues({ enterpriseId, data })
      : updateTransactionalProfile.createValues({ enterpriseId, data })
  );

  return {
    loading: loadingGet || loadingUpdate,
    error: errorGet || errorUpdate,
    hasTransactionalProfile,
    updateTransactionProfile,
    existingProfileData,
    transactionalProfileData,
    errorUpdate,
    loadingUpdate,
  };
};

export default useTransactionalProfileService;
